/**
 * Computes bar width as a percentage of the maximum value in a dataset.
 */
export function getBarWidthPercent(value: number, maxValue: number): number {
  if (!Number.isFinite(value) || !Number.isFinite(maxValue) || maxValue <= 0) {
    return 0;
  }
  return Math.min(100, Math.max(0, (value / maxValue) * 100));
}

/**
 * Returns the maximum numeric value from chart rows, with a floor of 1
 * to avoid division by zero.
 */
export function getChartMaxValue(values: number[]): number {
  const finiteValues = values.filter((value) => Number.isFinite(value));
  if (finiteValues.length === 0) return 1;
  return Math.max(1, ...finiteValues);
}
